import React from 'react';
import PropTypes from 'prop-types';
import addDomainToPath from 'commons/addDomainToPath';

import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPProductDetailsModalUI from './PDPProductDetailsModalUI';

const PDPProductDetailsModal = ({ isOpen, onClose }) => {
  const {
    loading,
    error,
    data: {
      id,
      productPDF,
      constructionDetails,
      productCareDetails,
      additional_attributes,
      assemblyDetailsPDF,
    },
  } = useProductAttributes();

  if (error) {
    return null;
  }

  return (
    <PDPProductDetailsModalUI
      isOpen={isOpen}
      onClose={onClose}
      loading={loading}
      productDetails={constructionDetails}
      productCare={productCareDetails}
      tearSheetLink={
        productPDF ? `https://jb-img.co/public_img/${productPDF}` : undefined
      }
      assemblyDetailsLink={
        assemblyDetailsPDF
          ? `https://jb-img.co/public_img/${assemblyDetailsPDF}`
          : undefined
      }
      productImage={
        additional_attributes?.fet_right_img
          ? addDomainToPath(
              `/products_additional/${id}/${encodeURIComponent(
                additional_attributes.fet_right_img
              )}`
            )
          : null
      }
    />
  );
};

PDPProductDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PDPProductDetailsModal;
